<template>
  <router-view />
</template>

<script>
import "@/assets/css/style.css";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      deferredPrompt: null,
    };
  },
  mounted() {
    window.addEventListener("beforeinstallprompt", (event) => {
      event.preventDefault();
      this.deferredPrompt = event;

      // چک کن که آخرین نمایش چه زمانی بوده
      const lastPromptTime = localStorage.getItem("lastInstallPrompt");
      const now = new Date().getTime();
      const oneWeek = 7 * 24 * 60 * 60 * 1000; // یک هفته به میلی‌ثانیه

      if (!lastPromptTime || now - lastPromptTime > oneWeek) {
        this.showInstallPrompt();
        localStorage.setItem("lastInstallPrompt", now);
      } else {
        console.log("پیشنهاد نصب اخیراً نمایش داده شده است.");
      }
    });
  },
  methods: {
    showInstallPrompt() {
      Swal.fire({
        title: false,
        text: "کاربری بهینه‌تر و دسترسی آسان‌تر به برنامه، بعداً نیز می‌توانید از طریق «Add to Home Screen» برنامه را نصب نمایید.",
        imageUrl: require("@/assets/images/logo.png"),
        imageWidth: 100,
        imageHeight: 100,
        showCancelButton: true,
        confirmButtonText: "بله، نصب کن",
        cancelButtonText: "نه، بعداً",
        customClass: {
          confirmButton: "confirm-btn",
          cancelButton: "cancel-btn",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.deferredPrompt.prompt();
          this.deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === "accepted") {
              Swal.fire({
                title: false,
                text: "برنامه با موفقیت نصب شد.",
                icon: "success",
                confirmButtonText: "تأیید",
                customClass: {
                  confirmButton: "confirm-btn",
                },
              });
            } else {
              Swal.fire({
                title: false,
                text: "شما می‌توانید بعداً نصب کنید.",
                icon: "error",
                confirmButtonText: "تأیید",
                customClass: {
                  confirmButton: "confirm-btn",
                },
              });
            }
            this.deferredPrompt = null;
          });
        }
      });
    },
  },
};
</script>

<style>
.div:where(.swal2-container).swal2-center>.swal2-popup {
  border-radius: 10px 0;
}

div:where(.swal2-container) div:where(.swal2-popup) {
  padding: 0 0 0.5em;
}

.swal2-actions {
  flex-wrap: nowrap;
}

.swal2-actions {
  width: 100%;
}

.confirm-btn {
  background-color: #39b449;
  color: white;
  border-radius: 10px 0;
  font-weight: 400;
  width: 100%;
}

.cancel-btn {
  background-color: #335d9d;
  color: white;
  border-radius: 10px 0;
  font-weight: 400;
  width: 100%;
}

.confirm-btn:hover {
  background-color: #45a049;
}

.cancel-btn:hover {
  background-color: #2a4a7a;
}
</style>
